import { MaskAtSpecifCharacter } from './types';

export const maskToRegExp = {
  '9': /\d/,
  '*': /[0-9a-zA-Z]/,
  a: /[a-zA-Z]/,
};

export const maskInputValue = (value = '', mask = '') => {
  let output = '';
  let maskIndex = 0;
  let valueIndex = 0;

  while (maskIndex < mask.length && valueIndex < value.length) {
    const maskAtSpecifCharacter = mask[maskIndex] as MaskAtSpecifCharacter;
    const regExpOfSpecifCharacter = maskToRegExp[maskAtSpecifCharacter];
    const isMaskCharacterMappedAsRegExp = !!regExpOfSpecifCharacter;
    const character = value[valueIndex];

    if (isMaskCharacterMappedAsRegExp) {
      if (regExpOfSpecifCharacter.test(character)) {
        output = `${output}${character}`;
        maskIndex++;
      }
      valueIndex++;
    } else {
      output += maskAtSpecifCharacter;
      if (character === maskAtSpecifCharacter) valueIndex++;
      maskIndex++;
    }
  }

  return output;
};
